<template>
    <div class="document-record mt-2">
    <v-form v-model="documentInstanceForm"> <!-- ToEdit -->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <!-- Change lg to 9 if another component is placed on the right  -->
        <div class="text-right mx-4 my-2">
        </div>
        <v-card class="mx-4 my-4">
            <v-card-title>
              Custom Documents
            </v-card-title>
            <v-row class="mx-4">
                <v-col cols="12" md="4">
                  <template>
                    <v-select
                        v-model="documentType"
                        :items="documentTypes"
                        small-chips
                        outlined
                        color="primary"
                        label="Select Document Type"
                        hide-details
                        dense
                        background-color="transparent"
                        item-value="id"
                        item-text="document_name"
                        class="mb-4 rounded-input"
                    ></v-select>
                  </template>
                </v-col>

                <v-col cols="12" md="2">
                  <v-btn
                    v-if="documentType"
                    @click="createDialog = true"
                    color="primary"
                    id="create-document"
                  >
                    Create
                  </v-btn>
                </v-col>

                <v-col cols="12" md="2">
                  <v-btn
                    v-if="documentType && documentTypes[documentTypes.findIndex(docType => docType.id === documentType)].import_file"
                    @click="importDialog = true"
                    color="white"
                    rounded
                    light
                    id="import-document"
                  >
                    Import
                  </v-btn>
                </v-col>
            </v-row>

            <intract-data-table
              v-if="documentType"
              :headers="getHeaders"
              :endpoint="documentInstancesEndpoint"
              :filter-fields="{}"
              ref="documentInstancesTable"
              show-select
              v-model="selectedDocuments"
              multiDelete
              :bulkDeleteEndpoint="documentsBulkDeleteEndpoint"
              :customActions="showPublishButton ? customActions : []"
            >
              <template v-slot:item.actions="{ item }" justify="center">
                <v-btn text color='primary' @click="handleEditClick(item)">
                  Edit
                </v-btn>
                <v-btn v-if="!showPublishButton || !item.published" text color='red' @click="deletingInstanceId = item.id; showDeleteConfirmationDialog = true">
                  Delete
                </v-btn>
                <v-btn v-if="showPublishButton" text :color="item.published ? 'red' : 'primary'" @click="() => togglePublishDocumentInstance(item.id, state=!item.published)">
                  <span v-if="item.published">Unpublish</span>
                  <span v-else>Publish</span>
                </v-btn>
                <v-btn text color='primary' @click="handleViewClick(item)">
                  View
                </v-btn>
              </template>
              <template v-slot:item.full_name="{ item }" justify="center">
                <span class="font-weight-medium">{{ item.student.full_name }}</span>
              </template>
              <template v-slot:item.classroom="{ item }" justify="center">
                <v-chip outlined small color="primary">{{ item.student.room ? item.student.room.sections : '-' }}</v-chip>
              </template>
              <template v-slot:item.created="{ item }" justify="center">
                <span>{{ moment(item.created).format('lll') }}</span>
              </template>
              <template v-slot:item.published="{ item }" justify="center">
                <v-icon v-if="item.published" color="primary">mdi-check</v-icon>
                <v-icon v-else color="red">mdi-close</v-icon>
              </template>
            </intract-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Document Instance Dialog Box -->
    <DocumentInstanceDialog
      @closeDialog="closeDialog()"
      :dialog="createDialog"
      :selectedDocumentType="documentType ? documentType : null"
      :formFields="headers"
      :is_editing="is_editing"
      :selectedDocumentInstance="selectedDocumentInstance"
    >
    </DocumentInstanceDialog>

    <DeleteConfirmationDialog 
      :visible="showDeleteConfirmationDialog"
      :title="`Are you sure you want to delete this document?`"
      description="You cannot undo this action"
      @deleteObject="deleteDocumentInstance"
    />

    <ConfirmationDialog
      :visible="publishConfirmationDialog"
      title="Are you sure you want to publish the selected documents?"
      description="To undo this action, you must unpublish individual documents from the list."
      successText="Publish"
      failureText="Cancel"
      @successCallback="publishDocuments"
      @failureCallback="publishConfirmationDialog = false"
    />

    <ImportExcelDialog
			:showDialog="importDialog"
			title="Import Data"
			@closeImportDialog="closeImportDialog"
			:endpoint="Helper.addUrlParams(endpoints.documentImport, [`template_id=${documentType}`])"
			:importFileUrl="getSampleFileUrl"
      allowClassroomSelection
      hideInstructions
		/>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" >
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
    </v-form>
  </div> 
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import DocumentInstanceDialog from '@components/templating/DocumentInstanceDialog.vue';
import IntractDataTable from "@components/widgets/generics/IntractDataTable.vue";
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog';
import moment from "moment";
import ImportExcelDialog from "@components/widgets/dialogs/ImportExcelDialog.vue";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog.vue";

export default {
  name: "ViewDocuments",
  components: {
    DocumentInstanceDialog,
    IntractDataTable,
    DeleteConfirmationDialog,
    ImportExcelDialog,
    ConfirmationDialog
  },
  data() {
    return {
      endpoints,
      Helper,
      documentType: null,
      is_editing: false,
      selectedDocumentInstance: null,
      showDeleteConfirmationDialog: false,
      publishConfirmationDialog: false,
      selectedDocuments: [],
      deletingInstanceId: null,
      documentInstanceForm:false,
      moment: moment,
      customActions:[
        {
          key: "bulk_publish",
          title: "Publish",
          icon: "mdi-upload",
          click: () => this.publishConfirmationDialog = true,
          class: "white--text",
          color: "primary",
        }
      ],
      createDialog: false,
      importDialog: false,
      documentTypes: null,
      documentInstances: null,
      snackbar: {
        visible: false,
        text: "",
        color: "dark",
      },
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser","isLoading", "currentInstitution"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },

    showPublishButton(){
      let selectedDocumentType = null;
      if (this.documentType){
        selectedDocumentType = this.documentTypes.find(
          (item) => item.id == this.documentType
        )
      }
      if (!this.documentType){
        return false;
      }
      return selectedDocumentType.publish_only
    },



    getHeaders(){
      let selectedDocumentType = null;
      if (this.documentType){
        selectedDocumentType = this.documentTypes.find(
          (item) => item.id == this.documentType
        )
      }
      
      const headers = [
        {
          text: 'Student',
          align: 'left',
          value: 'full_name'
        },
        {
          text: 'Classroom',
          align: 'center',
          value: 'classroom'
        },
        {
          text: 'Created',
          align: 'center',
          value: 'created'
        },
        ...selectedDocumentType && selectedDocumentType.publish_only ? [{
          text: 'Published',
          align: 'center',
          value: 'published',
        }] : [],
        {
          text: 'Actions',
          align: 'center',
          value: 'actions'
        },
      ]
      return headers
    },

    getSampleFileUrl(){
      if(this.documentType){
        const url = endpoints.documentTypes + this.documentType + "/import/get_sheet/";
        return url
      }
      return null
    },
    // can uncomment and use for detailed data in the datatable
    // documentTypeHeaders(){
    //   let documentTypeDetails = this.documentTypes.find(documentType => documentType.id == this.documentType)
    //   let sampleData = JSON.parse(documentTypeDetails.sample_context)
    //   let dynamicHeaders = [];
    //   Object.keys(sampleData).forEach(key => {
    //     dynamicHeaders.push({
    //       text: key.replaceAll('_', ' '),
    //       align: "center",
    //       value: `data.${key}`
    //     })
    //   })
    //   return [
    //     ...dynamicHeaders,
    //     ...this.headers
    //   ]
    // },

    documentInstancesEndpoint(){
      return Helper.addUrlParams(endpoints.documentInstances,[
        `template_document_type=${this.documentType}`
      ]);
    },

    documentsBulkDeleteEndpoint(){
      let url = endpoints.documentInstances + "bulk_delete/";
      return Helper.addUrlParams(url,[
        `template_document_type=${this.documentType}`
      ]);
    },

    documentsBulkPublishEndpoint(){
      let url = endpoints.documentInstances + "bulk_publish/";
      return Helper.addUrlParams(url, [
        `template_document_type=${this.documentType}`
      ])
    }
  },
  methods: {
    ...mapActions(["setLoading"]),

    async publishDocuments(){
      this.setLoading(true);
      let response = await api.call(
        this.apiEssentials,
        this.documentsBulkPublishEndpoint,
        api.Methods.POST,
        {
          publish_ids: this.selectedDocuments.map(
            (item) => item.id
          )
        }
      )
      if (response){
        this.snackbar.text = "Documents published successfully";
        this.snackbar.visible = true;
        this.$refs.documentInstancesTable.getAllItems();
        this.selectedDocuments = [];
      }
      this.publishConfirmationDialog = false;
    },
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    closeDialog(){
      this.createDialog = false;
      this.$refs.documentInstancesTable.getAllItems();
      if(this.is_editing)
        this.is_editing = false;
    },

    closeImportDialog(showDialog) {
			this.importDialog = showDialog
		},

    async getAllDocumentTypes(){
      this.documentTypes = await api.call(
        this.apiEssentials,
        endpoints.documentTypes
      );
    },

    async handleViewClick(instanceContext) {
      var url = endpoints.documentInstances + instanceContext.id + "/view/";
      var temp_doc_type = null
      for(var i=0; i<this.documentTypes.length; i++){
        if(this.documentTypes[i].id == this.documentType){
          temp_doc_type = this.documentTypes[i]
        }
      }
      var body = {
        institution: this.currentInstitution.id,
        data: JSON.stringify(instanceContext),
        template_document_type: temp_doc_type,
      }
      var response = await api.call(this.apiEssentials, url, api.Methods.GET, body);
      if(response){
        const blob = this.dataURItoBlob(response);
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      }
    },

    async handleEditClick(instanceContext){
      this.selectedDocumentInstance = instanceContext;
      this.is_editing = true;
      this.createDialog = true;
    },

    async deleteDocumentInstance(confirm){
      if(confirm){
        const url = endpoints.documentInstances + this.deletingInstanceId + "/"
        const response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
        if(response){
          this.deletingInstanceId = null
          this.$refs.documentInstancesTable.getAllItems();
        }
      }
      this.showDeleteConfirmationDialog = false;
      this.deletingInstanceId = null
    },

    async togglePublishDocumentInstance(itemId, state){
      const url = endpoints.documentInstances + itemId + "/publish/"
      const response = await api.call(this.apiEssentials, url, api.Methods.POST, {
        state
      });
      if(response){
        this.snackbar.text = `Document ${state ? "published" : "unpublished"} successfully`;
        this.snackbar.color = state ? "success" : "dark";
        this.snackbar.visible = true;
        this.$refs.documentInstancesTable.getAllItems();
      }
    },

    dataURItoBlob(dataURI) {
      const byteString = window.atob(dataURI);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
          int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: 'application/pdf' });
      return blob;
    },
  },
  created() {
    this.getAllDocumentTypes();
  },
};
</script>